export default "__VITE_ASSET__CoOEb3Mn__"